export default "__VITE_ASSET__03sErh0A0F1x6yI3rSUXkw__"